<ng-template #associatedMapModal let-c="close" let-d="dismiss">
  <form id="associated-mas" #associatedMapForm="ngForm" [class.submitted]="associatedMapForm.submitted"
        (ngSubmit)="processForm()" novalidate>
    <div class="modal-header">
      <h4 class="modal-title">Edit Map Associations</h4>
      <button type="button" class="btn btn-close" id="closeReferenceModalBtn" aria-label="Close" (click)="d()"></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <div class="row justify-content-md-center">
          <div class="col-10">
            <p>This insight has ({{totalAssociatedMap}}) map associations. You can add one or more associations below, and tag and association as a "key" association.</p>
          </div>
        </div>
        <div class="row justify-content-md-center" *ngIf="associatedMapAssigned.length > 0">
          <div class="col-10 association-list mb-2 mt-2">
            <div class="row" *ngFor="let item of associatedMapAssigned; let i = index">
              <div class="col-4">
                {{item.name}}
                <i class="fa fa-key" *ngIf="item.isKey === true"></i>
              </div>
              <div class="col-7">
              </div>
              <div class="col-1 text-center">
                <button type="button" class="btn btn-content-only btn-narrow" (click)="removeAssociatedMap(i)">
                  X
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="row justify-content-md-center">
          <div class="col-10">
            <div class="row">
              <p class="text-teal bold">+Add Another Map Association</p>
            </div>
          </div>
          <div class="col-10">
            <div class="row">
              <div class="col-4">
                <select name="newAssociatedMap" [(ngModel)]="newAssociatedMap"
                        class="form-control">
                  <option value="null">-</option>
                  <option [ngValue]="subItem"
                          *ngFor="let subItem of associatedMapList" [disabled]="isAlreadySelected(subItem.id)">{{subItem.name}}</option>
                </select>
              </div>
              <div class="col-7">
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                  <label [class.active]="newAssociatedMapKey === false" class="btn btn-outline-teal">
                    <input type="radio" name="newAssociatedMapKey" [value]="false" autocomplete="off" [(ngModel)]="newAssociatedMapKey"> NOT KEY
                  </label>
                  <label [class.active]="newAssociatedMapKey === true" class="btn btn-outline-teal">
                    <input type="radio" name="newAssociatedMapKey" [value]="true" autocomplete="off" [(ngModel)]="newAssociatedMapKey"> KEY
                  </label>
                </div>
              </div>
              <div class="col-1 text-center">
                <button type="button" class="btn btn-content-only btn-narrow text-teal bold" (click)="addAssociatedMap()">
                  +Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="resetForm(); c()">{{"GENERICS.CANCEL" | translate}}</button>
      <button type="submit" class="btn btn-primary">{{"GENERICS.SAVE" | translate}}</button>
    </div>
  </form>
</ng-template>
